import { useDynamicEntityCMSDataContext, useDynamicEntityStoreContext } from '../../contexts';

import { isTemplateString } from '../../lib';
import AssignedCategoryInput from '../_component_settings/inputs/AssignedCategoryInput';

export default function SEOItemWrapper({ id, label, addonLabel, seo, children, value }) {
  const { isTemplate } = useDynamicEntityCMSDataContext();

  const assignedCategory = useDynamicEntityStoreContext((state) => state.data.assigned_category);
  const isAssigned = assignedCategory && isTemplateString(value);
  const update = useDynamicEntityStoreContext((state) => state.update);

  return (
    <div>
      <div className="d-flex justify-content-between align-items-center mb-2">
        <label htmlFor={id} className="form-label mb-0">
          {label}
        </label>
        {isTemplate && seo ? (
          <button
            className="btn btn-sm btn-outline"
            onClick={() => {
              update({ activePane: 7, seoBeingEdited: seo });
            }}
          >
            <i className="fe fe-settings" />
          </button>
        ) : (
          <div />
        )}
      </div>
      {isAssigned ? (
        <div className="input-group">
          <AssignedCategoryInput addon="Assigned to" value={value} />
        </div>
      ) : (
        children
      )}
      <div className="form-text" id={`${id}-addon`}>
        {addonLabel}
      </div>
    </div>
  );
}
